export default "__VITE_ASSET__DO43Jy8H__"